// const axios = require("axios").default;
const { STATUS_200, STATUS_400 } = require("./constants");
const { APIError } = require("./exceptions");

const axios = window.axios.default

class CurifyClient {
    constructor(publicKey) {
        this.publicKey = publicKey;
        this.baseUrl = "https://api.flexecom.dev";
        this.headers = { "Content-Type": "application/json" };
    }

    async curePayment(amount, currencyCode, merchantProcessor, reference, customer, cardDetails, merchantInitiated, callback) {
        let responses = []
        const paymentInstrument = await this.createPaymentInstrument(cardDetails);
        paymentInstrument._type = "payment_instrument";
        responses.push({ ...paymentInstrument });
        callback(responses)
        responses.push({_type: "payment_intent"})
        setTimeout(() => callback(responses), 4000)
        let paymentIntent = await this.createPaymentIntent(amount, currencyCode, merchantProcessor, reference, customer, paymentInstrument, merchantInitiated);
        responses.push({ ...paymentIntent });
        callback(responses)

        return paymentIntent.status;
    }

    async createPaymentIntent(amount, currencyCode, merchantProcessor, reference, customer, paymentInstrument, merchantInitiated) {
        const url = `${this.baseUrl}/payment-intents`;
        const data = {
            public_key: this.publicKey,
            amount: amount.toString(),
            payment_instrument: paymentInstrument.id,
            currency_code: currencyCode,
            merchant_initiated: merchantInitiated,
            merchant_processor: merchantProcessor,
            reference: reference,
            customer: customer
        };

        return this._handleResponse(await axios.post(url, data, { headers: this.headers }));
    }

    async createPaymentInstrument(cardDetails) {
        const url = `https://tokenise.flexecom.dev/payment-instruments`;

        const data = {
            public_key: this.publicKey,
            ...cardDetails,
        }
        return this._handleResponse(await axios.post(url, data, { headers: this.headers }));
    }


    _handleResponse(response) {
        if (response.status >= STATUS_400) {
            throw new APIError(response.status, response.data.message || "Unknown error");
        }
        return response.data;
    }
}

module.exports = CurifyClient;
